import { render, staticRenderFns } from "./videojsplayer.vue?vue&type=template&id=721ab107&scoped=true"
import script from "./videojsplayer.ts?vue&type=script&lang=ts&external"
export * from "./videojsplayer.ts?vue&type=script&lang=ts&external"
import style0 from "./videojsplayer.less?vue&type=style&index=0&id=721ab107&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721ab107",
  null
  
)

export default component.exports